import getConfig from 'next/config'

import {
  getUsersWonLots as getUsersWonLotsLib,
  useGetUsersWonLots as useGetUsersWonLotsLib,
} from '@nx/api'
import { BonhamsCookies } from '@nx/global-types'

const { publicRuntimeConfig } = getConfig()

export const getUsersWonLots = (cookies: BonhamsCookies) =>
  getUsersWonLotsLib({ baseURL: publicRuntimeConfig.WEB_API_URL, cookies })

export const useGetUsersWonLots = () =>
  useGetUsersWonLotsLib({ baseURL: publicRuntimeConfig.WEB_API_URL })
